import supabase from 'lib/supabase-browser'

type Data = Record<string, any>

export async function apiRequest(path, method = 'GET', data?: Data) {
  const sessionData = await supabase.auth.getSession()
  const accessToken = sessionData.data.session
    ? sessionData.data.session.access_token
    : undefined

  const defaultHeaders = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  }

  return fetch(`/api/${path}`, {
    method: method,
    headers: defaultHeaders,
    body: data ? JSON.stringify(data) : undefined,
  })
    .then((response) => {
      try {
        return response.json()
      } catch (error) {
        return response
      }
    })
    .then((response) => {
      if (response.status === 'error') {
        // Automatically signout user if accessToken is no longer valid
        if (response.code === 'auth/invalid-user-token') {
          supabase.auth.signOut()
        }

        return response
      } else {
        return response.data || response.message || response
      }
    })
}

// Make an API request to any external URL
export function apiRequestExternal(url, method = 'GET', data) {
  return fetch(url, {
    method: method,
    headers: {
      accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: data ? JSON.stringify(data) : undefined,
  }).then((response) => response.json())
}

class CustomError extends Error {
  public code
  constructor(code, message) {
    super(message)
    this.code = code
  }
}
